import { Routes, Route } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { VerifyOtp } from './pages/VerifyOtp';
import { ForgotPassword } from './pages/ForgotPassword';
import { ResetPassword } from './pages/ResetPassword';
import { AdminLogin } from './pages/AdminLogin';
import { AdminDashboard } from './pages/AdminDashboard';
import { AdminProviderDetails } from './pages/AdminProviderDetails';
import { AdminReviewsPage } from './pages/AdminReviewsPage';
import { AdminBookingsPage } from './pages/AdminBookingsPage';
import { AdminDeleteRequestsPage } from './pages/AdminDeleteRequestsPage';
import { HomePage } from './pages/HomePage';
import { Settings } from './pages/Settings';
import { ProviderProfile } from './pages/ProviderProfile';
import { FindProviders } from './pages/FindProviders';
import { ProviderDetailPage } from './pages/ProviderDetailPage';
import { MyBookingsPage } from './pages/MyBookingsPage';
import { ProviderBookingsPage } from './pages/ProviderBookingsPage';
import MyPostsPage from './pages/MyPostsPage';
import AllPostsPage from './pages/AllPostsPage';
import { MessagesPage } from './pages/MessagesPage';
import { NotificationsPage } from './pages/NotificationsPage';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
import { CookiePolicy } from './pages/CookiePolicy';
import { CancellationPolicy } from './pages/CancellationPolicy';
import { SafeguardingPolicy } from './pages/SafeguardingPolicy';
import { ComplaintsProcedure } from './pages/ComplaintsProcedure';
import { AccessibilityStatement } from './pages/AccessibilityStatement';
import { CookieConsentBanner } from './components/CookieConsentBanner';
import { ROUTES } from './constants';
import { usePageTracking } from './hooks/usePageTracking';

function App() {
  usePageTracking();

  return (
    <>
      <Routes>
        <Route path={ROUTES.HOME} element={<Landing />} />
        <Route path={ROUTES.HOME_PAGE} element={<HomePage />} />
        <Route path={ROUTES.LOGIN} element={<Login />} />
        <Route path={ROUTES.REGISTER} element={<Register />} />
        <Route path={ROUTES.VERIFY_OTP} element={<VerifyOtp />} />
        <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPassword />} />
        <Route path={ROUTES.RESET_PASSWORD} element={<ResetPassword />} />
        <Route path={ROUTES.ADMIN_LOGIN} element={<AdminLogin />} />
        <Route path={ROUTES.ADMIN_DASHBOARD} element={<AdminDashboard />} />
        <Route path={ROUTES.ADMIN_PROVIDER_DETAILS} element={<AdminProviderDetails />} />
        <Route path={ROUTES.ADMIN_REVIEWS} element={<AdminReviewsPage />} />
        <Route path={ROUTES.ADMIN_BOOKINGS} element={<AdminBookingsPage />} />
        <Route path={ROUTES.ADMIN_DELETE_REQUESTS} element={<AdminDeleteRequestsPage />} />
        <Route path={ROUTES.SETTINGS} element={<Settings />} />
        <Route path={ROUTES.PROVIDER_PROFILE} element={<ProviderProfile />} />
        <Route path={ROUTES.FIND_PROVIDERS} element={<FindProviders />} />
        <Route path={`${ROUTES.PROVIDER_DETAIL}/:providerId`} element={<ProviderDetailPage />} />
        <Route path={ROUTES.MY_BOOKINGS} element={<MyBookingsPage />} />
        <Route path={`${ROUTES.MY_BOOKINGS}/:bookingId`} element={<MyBookingsPage />} />
        <Route path={ROUTES.PROVIDER_BOOKINGS} element={<ProviderBookingsPage />} />
        <Route path={`${ROUTES.PROVIDER_BOOKINGS}/:bookingId`} element={<ProviderBookingsPage />} />
        <Route path={ROUTES.MY_POSTS} element={<MyPostsPage />} />
        <Route path={ROUTES.ALL_POSTS} element={<AllPostsPage />} />
        <Route path={ROUTES.MESSAGES} element={<MessagesPage />} />
        <Route path={ROUTES.NOTIFICATIONS} element={<NotificationsPage />} />
        <Route path={ROUTES.PRIVACY_POLICY} element={<PrivacyPolicy />} />
        <Route path={ROUTES.TERMS_OF_SERVICE} element={<TermsOfService />} />
        <Route path={ROUTES.COOKIE_POLICY} element={<CookiePolicy />} />
        <Route path={ROUTES.CANCELLATION_POLICY} element={<CancellationPolicy />} />
        <Route path={ROUTES.SAFEGUARDING_POLICY} element={<SafeguardingPolicy />} />
        <Route path={ROUTES.COMPLAINTS_PROCEDURE} element={<ComplaintsProcedure />} />
        <Route path={ROUTES.ACCESSIBILITY} element={<AccessibilityStatement />} />
      </Routes>
      <CookieConsentBanner />
    </>
  );
}

export default App;
